import { action } from 'typesafe-actions';
import { EstoqueTypes, IEstoque, IFilter, IFiltroEstoque, Pagination } from './types';

export const loadRequest = (
  filtro: IFiltroEstoque | any,
  inscricaoAtiva: any,
  cddAtivo: number | undefined,
  pagination?: Pagination,
  sorter?: any
) => action(EstoqueTypes.LOAD_REQUEST, { filtro, inscricaoAtiva, cddAtivo, pagination, sorter });
export const loadSuccess = (data: IEstoque[], pagination: Pagination | null) =>
  action(EstoqueTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(EstoqueTypes.LOAD_FAILURE);

export const codParceiroSelecionado = (codParceiro: any) =>
  action(EstoqueTypes.COD_PARCEIRO, { codParceiro });

export const filterEstoque = (filter: IFilter) => action(EstoqueTypes.FILTER_ESTOQUE, { filter });

export const sorterEstoque = (ordenacao: any) => action(EstoqueTypes.SORTER_ESTOQUE, { ordenacao });

export const cleanStateEstoque = () => action(EstoqueTypes.CLEAN_ESTOQUE);
